import React, { useState, useEffect,useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuthService } from '../../services';
import { useNavigate } from 'react-router-dom';
import { InternetUserType } from '../../types/enum/user-type';
import { notify } from '../../util';
import { NotifyType, PageUrl, SessionKey } from '../../util/app-config';
import { useApiService, useContextService } from '../../services';
import { AppContext } from '../../contexts';

function AuthCallback() {
  let [searchParams, setSearchParams] = useSearchParams();
  const {getSPToken} = useAuthService();
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const { getRegistrationOnEnquiry, getRegistrationById } = useApiService();
  const { putContextInternetUser, putContextRegistration, patchContextRegistration } = useContextService();
  const { message } = notify();

  useEffect(()=>{
    var error = searchParams.get("error");
    var errorDescription = searchParams.get("error_description");
    var code=searchParams.get("code");
    var state=searchParams.get("state");

    if (error) {
      message(NotifyType.Error, errorDescription || "Singpass login failed");
      return;
    }

    if (!code || !state) {
      message(NotifyType.Error, "Singpass callback is missing authorization data");
      return;
    }

    const fetchData=async()=>{
        let tokenResponse=await getSPToken(code,state);
        if (tokenResponse && tokenResponse.isValidUser && tokenResponse.internetUser) {
          const jwt = tokenResponse.token ?? tokenResponse.jwt;
          if (jwt) {
            localStorage.setItem(SessionKey.InternetAuthToken, jwt);
          }
          await putContextInternetUser(tokenResponse.internetUser);
          if (tokenResponse.internetUser.type == InternetUserType.FoodHandler) {
              const regOnEnquirey = await getRegistrationOnEnquiry(tokenResponse.nric ?? tokenResponse.internetUser.nric);
              if (regOnEnquirey) {
                  const regOnId = await getRegistrationById(regOnEnquirey.id)
                  if (regOnId) {
                      await putContextRegistration(regOnId, true);
                      navigate(PageUrl.Registration)
                  }
              } else {
                  await patchContextRegistration(tokenResponse.nric ?? tokenResponse.internetUser.nric);
                  navigate(PageUrl.Registration)
              }
          } else {
              navigate(PageUrl.Company)
          }
      } else {
          message(NotifyType.Error, "User Login Failed")
      }
  }
  fetchData();
},[])


  return (
    <div>
      <div>Redirecting.........</div>
    </div>
  );
}

export default AuthCallback;
